module.exports = __webpack_public_path__ + "static/media/portfolio8-6.ee93cf7a.png";